import { REDUCER_NAME } from './const'
import { selectOwnState as selectParentState } from '../selector'
import { createTableSettingSelector } from '../../../form/state/table-state-helper'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectIsFetching = (state) => {
    return selectOwnState(state).fetching
}

export const selectTableSetting = createTableSettingSelector(selectOwnState)



// WEBPACK FOOTER //
// ./src/modules/customer/state/cbct-file-upload/selector.js